import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import BrandLogo from './BrandLogo';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setMessage('No verification token found. Please check your email link.');
      return;
    }

    api.post('/auth/verify-email', { token })
      .then(res => {
        setStatus('success');
        setMessage(res.data?.message || 'Email verified successfully!');
      })
      .catch(err => {
        setStatus('error');
        setMessage(err.response?.data?.error || 'Verification failed. The link may have expired.');
      });
  }, [searchParams]);

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div style={{ background: 'var(--bg-card)', borderRadius: '16px', padding: '40px', maxWidth: '460px', width: '100%', textAlign: 'center', border: '1px solid var(--border-color)' }}>
        <BrandLogo height={42} showBeta style={{ marginBottom: 22 }} />
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>
          {status === 'verifying' ? '⏳' : status === 'success' ? '✅' : '❌'}
        </div>
        <h2 style={{ color: status === 'success' ? 'var(--accent)' : status === 'error' ? 'var(--danger)' : 'var(--text-secondary)', marginBottom: '12px' }}>
          {status === 'verifying' ? 'Verifying...' : status === 'success' ? 'Email Verified!' : 'Verification Failed'}
        </h2>
        <p style={{ color: 'var(--text-primary)', lineHeight: '1.6', marginBottom: '24px' }}>{message}</p>
        {status === 'success' && (
          <button onClick={() => navigate('/login')} style={{
            padding: '12px 32px', background: 'var(--accent)', color: 'var(--text-on-accent)', border: 'none',
            borderRadius: '8px', fontWeight: 'bold', fontSize: '16px', cursor: 'pointer'
          }}>Go to Login</button>
        )}
        {status === 'error' && (
          <button onClick={() => navigate('/login')} style={{
            padding: '12px 32px', background: 'var(--border-input)', color: 'var(--text-secondary)', border: 'none',
            borderRadius: '8px', fontWeight: 'bold', fontSize: '14px', cursor: 'pointer'
          }}>Back to Login</button>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;
